import React, { useState } from "react";
import BreathingCircle from "../components/BreathingCircle";
import { Hand, Eye, Ear, Wind, Heart } from "lucide-react";

const GROUNDING = [
  { count: 5, sense: "things you can see", icon: Eye },
  { count: 4, sense: "things you can touch", icon: Hand },
  { count: 3, sense: "things you can hear", icon: Ear },
  { count: 2, sense: "things you can smell", icon: Wind },
  { count: 1, sense: "thing you can taste", icon: Heart },
];

export default function Toolkit() {
  const [running, setRunning] = useState(false);

  return (
    <div className="space-y-6 fade-up" data-testid="toolkit-page">
      <header>
        <h1 className="font-display text-3xl font-bold text-slate-900">Coping toolkit</h1>
        <p className="text-slate-600 mt-2 max-w-xl">Quick, evidence-based exercises to ground yourself when distress rises.</p>
      </header>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6" data-testid="toolkit-breathing">
        <div className="flex items-end justify-between">
          <div>
            <h2 className="font-display text-xl font-bold text-slate-900">Box breathing</h2>
            <p className="text-sm text-slate-500 mt-1">Breathe in 4 · hold 4 · breathe out 4 · hold 4. Repeat four cycles.</p>
          </div>
          <button
            data-testid="toolkit-breathing-toggle"
            onClick={() => setRunning((r) => !r)}
            className={`rounded-xl px-4 py-2 text-sm font-semibold ${
              running ? "bg-slate-100 text-slate-700 border border-slate-300" : "bg-teal-700 hover:bg-teal-800 text-white"
            }`}
          >
            {running ? "Pause" : "Start"}
          </button>
        </div>
        <BreathingCircle running={running} />
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6" data-testid="toolkit-grounding">
        <h2 className="font-display text-xl font-bold text-slate-900">5-4-3-2-1 grounding</h2>
        <p className="text-sm text-slate-500 mt-1 mb-5">Use your senses to come back to the present moment.</p>
        <div className="space-y-2">
          {GROUNDING.map((g, i) => (
            <div key={i} className="flex items-center gap-3 bg-teal-50 rounded-xl px-4 py-3" data-testid={`grounding-step-${g.count}`}>
              <div className="w-10 h-10 rounded-xl bg-teal-700 text-white flex items-center justify-center font-display text-lg font-bold">{g.count}</div>
              <div className="flex items-center gap-2 text-slate-800">
                <g.icon className="w-4 h-4 text-teal-700" />
                {g.sense}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6" data-testid="toolkit-safe-place">
        <h2 className="font-display text-xl font-bold text-slate-900">Safe place visualisation</h2>
        <p className="text-sm text-slate-500 mt-1">Close your eyes and picture somewhere you feel calm — real or imagined.</p>
        <ol className="mt-4 space-y-2 text-slate-700 text-sm list-decimal list-inside">
          <li>What does it look like? Notice the colours and the light.</li>
          <li>What sounds are present? Wind, water, voices?</li>
          <li>What does it feel like under your feet?</li>
          <li>Take three slow breaths and stay here as long as you need.</li>
        </ol>
      </div>
    </div>
  );
}
